<template>
  <div class="child-route-wrapper">
    <div class="confirmation-box">
      <div class="thank-you-header">
        <h2 class="thank-you-title">
          Thank you
        </h2>
        <close-icon-thick
          class="close-button"
          @click="onSubmit"
        />
      </div>
      <div class="separator" />
      <div class="workspace-setup-message">
        We're setting up your workspace.
        <br> You’ll receive an email soon with all the details you need to get started.
      </div>
      <div class="separator" />
      <b-button
        class="registration-button confirm-button"
        @click="onSubmit"
      >
        Confirm
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import CloseIconThick from '@/@core/assets/svg-components/CloseIconThick.vue'
import { apiToastSuccess } from '@core/utils/toast'
import analytics from '@/@core/utils/analytics'
import mixpanelTracks from '@/mixpanel-tracks'
import { RESET_FORM_DATA } from '@/store/modules/register.module'
import store from '@/store'

export default {
  name: 'Confirm',
  components: {
    BButton,
    CloseIconThick,
  },
  mounted() {
    analytics.track(mixpanelTracks.ACTIONS.REGISTER_V2.THANK_YOU_VIEW)
  },
  methods: {
    onSubmit() {
      analytics.track(mixpanelTracks.ACTIONS.REGISTER_V2.THANK_YOU_CONFIRM_CLICK)
      store.commit(RESET_FORM_DATA)
      this.$router.push({
        path: '/login',
      })
      apiToastSuccess(
        "You have successfully registered! Let's login!",
        'CoffeeIcon',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../common-styles.scss';

.confirmation-box {
  display: flex;
  width: 500px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  border: 1px solid var(--Components-Forms-Input-border, #CED4DA);
  background: var(--global-09-white, #FFF);
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.thank-you-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  align-self: stretch;
  position: relative;
  padding: 20px;
}

.thank-you-title {
  font-size: 24px;
  font-weight: 600;
  color: #343A40;
  margin: 0;
  text-align: center;
  width: 100%;
}

.close-button {
  right: 0;
  cursor: pointer;
}

.separator {
  width: 100%;
  height: 1px;
  background-color: var(--Components-Forms-Input-border, #CED4DA);
}

.workspace-setup-message {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  color: #343A40;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-button {
  margin: 16px;
  width: 100%;
  color: var(--global-09-white, #FFF);
  text-align: center;
  font-family: "SF Pro Display", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: -webkit-fill-available;
}

@media screen and (max-width: 660px) {
  .confirmation-box {
    width: 100%;
    max-width: 450px;
    padding: 16px;
  }

  .thank-you-title {
    font-size: 20px;
  }

  .workspace-setup-message {
    font-size: 14px;
  }
}

@media screen and (max-width: 425px) {
  .confirmation-box {
    max-width: 100%;
    padding: 12px;
  }
}
</style>
